"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountTokens = exports.TokensController = void 0;
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var Tokens_1 = require("./Tokens");
var Types_1 = require("@CommonFrontendBackend/Hubspot/Types");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var TokensController = (function (_super) {
    __extends(TokensController, _super);
    function TokensController(props) {
        var _this = _super.call(this, props) || this;
        _this.tokens = [];
        _this.isLoading = false;
        _this.isCompanySelected = false;
        _this.companyId = null;
        _this.selectObjectToken = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, tokens, companyId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setIsCompanySelected(false);
                        return [4, this.fetchObjectTokens(this.props.objectId, this.props.objectType)];
                    case 1:
                        _a = _b.sent(), tokens = _a.tokens, companyId = _a.companyId;
                        this.setCompanyId(companyId);
                        this.setTokens(tokens);
                        return [2];
                }
            });
        }); };
        _this.selectAssociatedCompany = function () { return __awaiter(_this, void 0, Promise, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setIsCompanySelected(true);
                        return [4, this.fetchAssociatedCompanyTokens(this.companyId)];
                    case 1:
                        tokens = _a.sent();
                        tokens.forEach(function (token) {
                            token.name = "company.".concat(token.name);
                            return token;
                        });
                        this.setTokens(tokens);
                        return [2];
                }
            });
        }); };
        _this.fetchObjectTokens = function (objectId, objectType) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this.fetchTokens(objectId, objectType)];
            });
        }); };
        _this.fetchAssociatedCompanyTokens = function (companyId) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetchTokens(companyId, Types_1.AssociatedObjectType.Company)];
                    case 1: return [2, (_a.sent()).tokens];
                }
            });
        }); };
        _this.fetchTokens = function (objectId, objectType) { return __awaiter(_this, void 0, Promise, function () {
            var apiBaseUrl, response, tokens, companyId;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        apiBaseUrl = this.props.apiBaseUrl;
                        this.setIsLoading(true);
                        return [4, axios_1.default.get("".concat(apiBaseUrl, "/integration/hubspot/tokens"), {
                                params: {
                                    objectType: objectType,
                                    objectId: objectId,
                                },
                                withCredentials: true,
                            })];
                    case 1:
                        response = _c.sent();
                        this.setIsLoading(false);
                        tokens = !!((_a = response.data) === null || _a === void 0 ? void 0 : _a.tokens) ? this.processFetchedTokens(response.data.tokens) : [];
                        companyId = !!((_b = response.data) === null || _b === void 0 ? void 0 : _b.companyId) ? response.data.companyId : null;
                        return [2, {
                                tokens: tokens,
                                companyId: companyId,
                            }];
                }
            });
        }); };
        _this.processFetchedTokens = function (tokens) {
            return lodash_1.default.filter(tokens, function (token) {
                var _a;
                return ((_a = token.name) === null || _a === void 0 ? void 0 : _a.indexOf("hs_")) !== 0 && token.name !== "company";
            });
        };
        _this.selectObjectToken();
        return _this;
    }
    TokensController.prototype.render = function () {
        var objectType = this.props.objectType;
        return (react_1.default.createElement(Tokens_1.Tokens, { objectType: objectType, isCompanySelected: this.isCompanySelected, isLoading: this.isLoading, tokens: this.tokens, selectObjectToken: this.selectObjectToken, selectAssociatedCompany: this.selectAssociatedCompany }));
    };
    TokensController.prototype.setIsLoading = function (isLoading) {
        this.isLoading = isLoading;
    };
    TokensController.prototype.setIsCompanySelected = function (isCompanySelected) {
        this.isCompanySelected = isCompanySelected;
    };
    TokensController.prototype.setCompanyId = function (companyId) {
        this.companyId = companyId;
    };
    TokensController.prototype.setTokens = function (tokens) {
        this.tokens = tokens;
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], TokensController.prototype, "tokens", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokensController.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokensController.prototype, "isCompanySelected", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokensController.prototype, "companyId", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokensController.prototype, "setIsLoading", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokensController.prototype, "setIsCompanySelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TokensController.prototype, "setCompanyId", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TokensController.prototype, "setTokens", null);
    TokensController = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokensController);
    return TokensController;
}(react_1.default.Component));
exports.TokensController = TokensController;
var mountTokens = function (mountReactComponent, apiBaseUrl, objectType, objectId) {
    return mountReactComponent(react_1.default.createElement(TokensController, { apiBaseUrl: apiBaseUrl, objectType: objectType, objectId: objectId }));
};
exports.mountTokens = mountTokens;
